import {getMethod, postMethod, putMethod, patchMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownCharterContracts', request)
}

async function post(request) {
    return await postMethod('/api/ownCharterContracts', request)
}

async function put(request) {
    return await putMethod('/api/ownCharterContracts', request)
}

async function patch(id, request) {
    return await patchMethod(`/api/ownCharterContracts/${id}`, request)
}

export {get, post, put, patch}
